/*!
 web2sign compatibility shims

 Most are as found on MDN and released under the Public Domain.
 https://developer.mozilla.org/en-US/docs/MDN/About
*/

if (!String.prototype.startsWith)
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };

if (!window.localStorage)
    window.localStorage = {};

if (!window.console || !window.console.log) // IE8 with closed developer tools
    window.console = { log: function () {} };
